import React from "react";

function ProgressMeterBlob({onClick, name, position, currentPosition, maxCompletedStep})
{
    return (
        <>
            {position !== 1 && <div className={"stepFill" + (maxCompletedStep >= position ? ' stepFillComplete' : '')}></div>}
            <div className={"step" + (maxCompletedStep >= position ? ' stepComplete' : '') + (currentPosition === position ? ' stepActive' : '')} onClick={maxCompletedStep < position ? null : onClick}><p>{name}</p></div>
        </>
    )
}

export default ProgressMeterBlob;